// Last-good API data kept on this device (stale-while-revalidate): revisits paint instantly
// from here while fresh data loads. Cleared on log out / expired session.
const PREFIX = "shs_cache:";
const MAX_CHARS = 2500000; // stay well under the ~5 MB localStorage quota

export const readCache = (key) => {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const writeCache = (key, data) => {
  try {
    const raw = JSON.stringify({ data, at: Date.now() });
    if (raw.length > MAX_CHARS) localStorage.removeItem(PREFIX + key);
    else localStorage.setItem(PREFIX + key, raw);
  } catch { /* quota full or storage disabled — just skip caching */ }
};

export const clearCache = () => {
  try {
    Object.keys(localStorage).filter((k) => k.startsWith(PREFIX)).forEach((k) => localStorage.removeItem(k));
  } catch { /* storage disabled — nothing cached */ }
};
